function vzSearchInit() {
  initSearchLoad();

  jQuery('.show-searchform').on('click', function() {
    setTimeout(function() {
      jQuery('.search-field').eq(0).focus();
    }, 1000);
  });
}

/**
 *
 */
function initSearchLoad() {
  if (!jQuery('body.search-results').length) {
    return;
  }

  const $searchResults = jQuery('.wav-get-more-search-results');

  const url = getSearchResultUrl($searchResults.data('page'));
  checkSearchResultsNextPage(url, $searchResults.parent());

  $searchResults.on('click', function() {
    const page = parseInt($searchResults.data('page'));
    const url = getSearchResultUrl(page);
    const checkUrl = getSearchResultUrl(page + 1);
    checkSearchResultsNextPage(checkUrl, $searchResults.parent());

    jQuery.ajax({
      type: 'GET',
      url: url,
      dataType: 'HTML',
      cache: false,
      success: function(response) {
        const nextPage = parseInt($searchResults.data('page')) + 1;
        $searchResults.data('page', nextPage);

        jQuery(response)
            .find('main.main article')
            .insertBefore($searchResults.parent());
      }
    });
  });
}

/**
 *
 * @param url
 * @param $buttonParent
 */
function checkSearchResultsNextPage(url, $buttonParent) {
  jQuery.ajax({
    type: 'GET',
    url: url,
    dataType: 'HTML',
    cache: false,
    success: function() {
      $buttonParent.removeClass('hide');
    },
    error: function() {
      $buttonParent.addClass('hide');
    }
  });
}

/**
 *
 * @param page
 * @returns {string}
 */
function getSearchResultUrl(page) {
  const url = location.href;
  const urlHost = url.split('/').splice(0, 3);
  const urlParts = url.split('?');

  return urlHost.join('/') + '/page/' + page + '/?' + urlParts[1];
}
